import { provideGlobalConfig } from '@jdesign-vue/components/config-provider'
import { INSTALLED_KEY } from '@jdesign-vue/constants'
import { version } from './version'

import type { App, Plugin } from '@vue/runtime-core'
import type { ConfigProviderContext } from '@jdesign-vue/components/config-provider'

export const makeInstaller = (components: Plugin[] = []) => {
  const install = (app: App, options?: ConfigProviderContext) => {
    if (app[INSTALLED_KEY]) return

    app[INSTALLED_KEY] = true
    components.forEach((c) => app.use(c))

    if (options) {
      provideGlobalConfig(options, app, true)
      // 根据locale的name属性设置document.documentElement的internationalization属性
      if (options.locale?.name && typeof document !== 'undefined') {
        const normalizedLang = options.locale.name
          .toLowerCase()
          .replace('_', '-')
        const isChineseLocale = ['zh-cn', 'zh-tw'].includes(normalizedLang)
        // 设置internationalization属性用于CSS字体选择 (true表示非中文，false表示中文)
        const htmlCollection = document.querySelectorAll('html')
        const htmlList = [...htmlCollection]
        if (htmlList && htmlList.length > 0) {
          const ns = options.namespace || 'jd'
          htmlList.forEach((html) => {
            html.setAttribute(
              `${ns}-internationalization`,
              String(!isChineseLocale)
            )
          })
        }
      }
    }
  }

  return {
    version,
    install,
  }
}
